import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/testimonials";

export default function TestimonialSection() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6">
        <SectionHeading
          kicker="用户口碑"
          title="他们为什么愿意一直看下去"
          desc="来自长期读者与内容从业者的反馈。我们原样保留，没有润色成统一的夸奖。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-300 bg-background-50 p-5"
            >
              <span className="mb-4 flex h-7 w-7 items-center justify-center text-accent-500">
                <i className="ri-double-quotes-l text-2xl" />
              </span>
              <blockquote className="mb-5 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.quote}
              </blockquote>
              <figcaption className="flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                  {item.initials}
                </span>
                <span className="min-w-0">
                  <span className="block font-heading text-sm font-bold text-foreground-950">
                    {item.name}
                  </span>
                  <span className="block font-label text-xs text-foreground-500">
                    {item.role}
                  </span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}